import React from 'react'
import { Card, Box, Link, Tooltip, styled } from '@mui/material'
import { EditIcon } from 'packages/eid-icons'
import { useTranslation } from 'react-i18next'
import { Slope } from 'images'
import config from 'config'

const StyledCard = styled(Card)(({ maxWidth }) => ({
    overflow: 'visible',
    maxWidth: maxWidth && maxWidth,
}))

const StyledEditOption = styled(Box)({
    display: 'flex',
    justifyContent: 'center',
    position: 'relative',

    '> img': {
        bottom: '-0.1rem',
    },
})

const StyledIconBox = styled(Box)({
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '-2.285em',
    backgroundColor: '#eef0f4',
    height: '68px',
    width: '95px',
    borderRadius: '50%',
    alignItems: 'center',
})

const StyledLink = styled(Link)({
    height: '45px',
    width: '45px',
    backgroundColor: '#FFF',
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    boxShadow: '0 5px 4px 0 rgba(0, 0, 0, 0.1)',
})

const GenericCard = ({
    editIcon,
    width,
    onClick,
    editable,
    helpText,
    children,
    showEditOption,
}) => {
    const { t } = useTranslation()

    if (editIcon) {
        var Icon = React.createElement(editIcon, {
            color: editable ? '#0057A0' : '#b4b4b4',
        })
    }
    return (
        <StyledCard maxWidth={width}>
            {children}

            {showEditOption && (
                <StyledEditOption>
                    <img
                        style={{ position: 'absolute' }}
                        src={`${config.APP_SUBPATH}${Slope}`}
                        alt=""
                        aria-hidden="true"
                    />
                    <StyledIconBox>
                        <Tooltip
                            title={
                                helpText
                                    ? helpText
                                    : editable
                                    ? t('ClickToEdit')
                                    : t('YouDontHavePermissionToEdit')
                            }
                        >
                            <StyledLink
                                component="button"
                                onClick={onClick}
                                aria-label={
                                    helpText
                                        ? helpText
                                        : editable
                                        ? t('ClickToEdit')
                                        : t('YouDontHavePermissionToEdit')
                                }
                                data-ai-explain={
                                    editable
                                        ? 'Edit this section'
                                        : 'Edit this section (no permission)'
                                }
                            >
                                {editIcon ? (
                                    Icon
                                ) : (
                                    <EditIcon
                                        color={editable ? '#0057A0' : '#b4b4b4'}
                                    />
                                )}
                            </StyledLink>
                        </Tooltip>
                    </StyledIconBox>
                </StyledEditOption>
            )}
        </StyledCard>
    )
}

export default GenericCard
